<div class="loginContainer">
  <div class="card mx-auto">
    <div class="card-body">
      <h5 class="card-title text-center">Login</h5>
      <form>
        <div class="form-group">
          <label for="username">Username</label>
          <input type="text" class="form-control bg-dark text-light border-secondary" id="username"
            placeholder="Username" #username (keyup.enter)="signIn(username.value, pwd.value)">
        </div>
        <div class="form-group">
          <label for="pwd">Password</label>
          <input type="password" class="form-control bg-dark text-light border-secondary" id="pwd"
            placeholder="Password" #pwd (keyup.enter)="signIn(username.value, pwd.value)">
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="message != null">{{ message }}</div>
        <button type="button" class="btn mt-3 btn-primary" (click)="signIn(username.value, pwd.value)">Submit</button>
      </form>
    </div>
  </div>
</div>